import { render, staticRenderFns } from "./DealershipsAddEdit.vue?vue&type=template&id=89dc4314&scoped=true"
import script from "./DealershipsAddEdit.vue?vue&type=script&lang=ts"
export * from "./DealershipsAddEdit.vue?vue&type=script&lang=ts"
import style0 from "./DealershipsAddEdit.vue?vue&type=style&index=0&id=89dc4314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89dc4314",
  null
  
)

export default component.exports